document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('.panda-pers');
  if (!section) return;

  var input = section.querySelector('[data-pers-input]');
  var preview = section.querySelector('[data-pers-preview]');
  var counter = section.querySelector('[data-pers-counter]');
  var applyBtn = section.querySelector('[data-pers-apply]');
  var opts = section.querySelectorAll('[data-pers-opt]');

  if (input) {
    input.addEventListener('input', function () {
      if (preview) preview.textContent = input.value || preview.dataset.defaultText || '';
      if (counter) counter.textContent = input.value.length;
    });
  }

  opts.forEach(function (opt) {
    opt.addEventListener('click', function () {
      opts.forEach(function (o) {
        o.classList.remove('panda-is-active');
      });
      opt.classList.add('panda-is-active');
    });
  });

  if (applyBtn) {
    applyBtn.addEventListener('click', function () {
      var realInput = document.querySelector('[data-engraving-input]');
      if (realInput && input && input.value.trim()) {
        realInput.value = input.value.trim();
        realInput.dispatchEvent(new Event('input', { bubbles: true }));
        realInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        realInput.focus();
      }
    });
  }
});
